import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=8fbca6ee&scoped=true&"
import script from "./EmptyState.vue?vue&type=script&lang=ts&"
export * from "./EmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyState.vue?vue&type=style&index=0&id=8fbca6ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbca6ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-cfm/mfe-cfm/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fbca6ee')) {
      api.createRecord('8fbca6ee', component.options)
    } else {
      api.reload('8fbca6ee', component.options)
    }
    module.hot.accept("./EmptyState.vue?vue&type=template&id=8fbca6ee&scoped=true&", function () {
      api.rerender('8fbca6ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data/EmptyState.vue"
export default component.exports